import React, { useEffect } from "react";
import useStaticContext from "@hooks/useStaticContext";
import useStores from "@hooks/useStores";
import { observer } from "mobx-react";
import SchemaOrg from "@components/Global/Custom/SchemaOrg";

import ComboMainSection from "./ComboMainSection";
import ComboBanner from "./ComboBanner";
import ComboBreadcrumbs from "./ComboBreadcrumbs";
import ComboNearByLocations from "./ComboNearByLocations";
import ComboRelatedServices from "./ComboRelatedServices";

import ProList from "../../Global/Custom/ProList/ProList";
import HowItWorks from "../Shared/HowItWorks";
import CoursesAndGuides from "../Shared/CoursesAndGuides";
import Header from "../Shared/Header";
import Footer from "../Shared/Footer";

import schema from "./@data/schema.org";
import FAQ from "@components/Main/Shared/FAQ";
import { LeadFunnelModal } from "@components/Main/Shared/LeadFunnel";
import ComboReviews from "./ComboReviews";
import LazyLoadComponent from "@custom/LazyLoad";

const Combo = observer(() => {
	const { comboStore: store, leadFunnelModalStore } = useStores();
	const staticContext = useStaticContext();
	const { zip: userZipcode } = staticContext.app.location;
	const { service, midtail, city, providers, popularCities, popularServices } =
		staticContext;

	useEffect(() => {
		if (leadFunnelModalStore.show) {
			store.hasShowLeadFunnelModal = true;
		}
	}, [leadFunnelModalStore.show]);

	const seeMoreOnClickHandler = () => (window.location.href = store.searchLink);

	return (
		<React.Fragment>
			<Header searchBar={false} />
			<ComboBanner
				service={service}
				midtail={midtail}
				city={city}
				zipcode={city.zipcode || userZipcode}
			/>
			<ComboBreadcrumbs service={midtail || service} city={city} />
			<ComboMainSection
				proCount={providers.length}
				city={city}
				service={midtail || service}
			>
				<ProList
					providers={providers}
					serveCity={{ city: city.name, state: city.state }}
					seeMoreOnClickHandler={seeMoreOnClickHandler}
				/>
			</ComboMainSection>
			<FAQ service={midtail || service} city={city} />
			<ComboReviews city={city} service={midtail || service} />
			<HowItWorks />
			<ComboNearByLocations
				popularCities={popularCities}
				service={midtail || service}
				city={city}
			/>
			<ComboRelatedServices
				service={midtail || service}
				popularServices={popularServices}
				city={city}
			/>
			<CoursesAndGuides
				related_services={popularServices}
				service={midtail || service}
			/>
			<SchemaOrg
				schema={schema({ service: midtail || service, providers, city })}
			/>
			<Footer />
			{store.hasShowLeadFunnelModal && (
				<LeadFunnelModal
					midtail={midtail}
					provider={store.provider}
					service={store.service}
					zipcode={store.zipcode}
					base64EncodedAnswerKeys={store.base64EncodedAnswerKeys}
				/>
			)}
		</React.Fragment>
	);
});

export default Combo;
